import { z } from 'zod'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  GeoMultiPolygon: { input: string; output: string; }
  GeoPoint: { input: string; output: string; }
  GeoPolygon: { input: string; output: string; }
  Instant: { input: string; output: string; }
  Long: { input: number; output: number; }
  TimeZone: { input: string; output: string; }
  UUID: { input: string; output: string; }
};

/** Contextual information about the requesting user as it pertains to this message */
export type About = {
  __typename?: 'About';
  /**
   *
   *             Indicates the requesting user can acknowledge this message. True if the message has acknowledgments configured,
   *             the message is PUBLISHED, the requesting user is a recipient of the message, and they have not yet acknowledged
   *
   */
  canAck: Scalars['Boolean']['output'];
  /** Indicates if the requesting user has an acknowledgement recorded for this message */
  didAck: Scalars['Boolean']['output'];
};

export type AboutMembershipNode = {
  __typename?: 'AboutMembershipNode';
  allMembers: Array<UserNode>;
  allMembersCount: Scalars['Int']['output'];
  directMembers: Array<UserNode>;
  directMembersCount: Scalars['Int']['output'];
};


export type AboutMembershipNodeAllMembersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type AboutMembershipNodeDirectMembersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type AccessTokenInfoInput = {
  expiration?: InputMaybe<Scalars['Instant']['input']>;
  name: Scalars['String']['input'];
  /** When called by support, specifies the userId that should be associated with this token. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AccessTokenNode = {
  __typename?: 'AccessTokenNode';
  expiration?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['UUID']['output'];
  isExpired: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['Instant']['output']>;
  name: Scalars['String']['output'];
};

export type AddressNode = {
  __typename?: 'AddressNode';
  city: Scalars['String']['output'];
  geoPoint: Scalars['GeoPoint']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type AssignCustomerRoleParamsInput = {
  roleId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AssignGroupRoleParamsInput = {
  groupId: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AssignIpawsRoleParamsInput = {
  ipawsCertId: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AssignTopicRoleParamsInput = {
  roleId: Scalars['UUID']['input'];
  topicId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AudienceInfoInput = {
  geofilters: Array<Scalars['UUID']['input']>;
  geometries: Array<Scalars['GeoPolygon']['input']>;
  groups: Array<Scalars['UUID']['input']>;
  topics: Array<Scalars['UUID']['input']>;
  users: Array<Scalars['UUID']['input']>;
};

export type AudienceNode = {
  __typename?: 'AudienceNode';
  geofilters: Array<GeoFilterNode>;
  geometries: Array<Scalars['GeoPolygon']['output']>;
  groups: Array<GroupNode>;
  id: Scalars['UUID']['output'];
  topics: Array<TopicNode>;
  users: Array<UserNode>;
};

export type AuthorizedMutation = {
  __typename?: 'AuthorizedMutation';
  /** Creates an ingest rule to route incoming message ingestions. */
  createIngestRule: IngestRuleNode;
  /** Creates a new phone number record in the available phone number table. */
  createPhoneNumber: Array<PhoneNumberNode>;
  /** Permanently deletes an ingest rule. */
  deleteIngestRule: IngestRuleNode;
  /** Deletes a phone number record from the available phone number table. */
  deletePhoneNumber: Array<PhoneNumberNode>;
  /** Sets the phone numbers for the current customer. */
  setCustomerPhoneNumbers: CustomerNode;
  /** Sets the SendGrid Dynamic Template ID used on alerts sent via email */
  setDynamicTemplateId: Scalars['Boolean']['output'];
  /** Manually mark an EUD as verified */
  setEudVerified: EudNode;
  /** Sets the list of the enabled features for the customer. */
  setFeatures: CustomerNode;
  /** Sets the type of a given template. This is often used by support for the creation of system template in existing customers. */
  setTemplateType: TemplateNode;
  updateIngestRule: IngestRuleNode;
};


export type AuthorizedMutationCreateIngestRuleArgs = {
  params: IngestRuleInfoInput;
};


export type AuthorizedMutationCreatePhoneNumberArgs = {
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type AuthorizedMutationDeleteIngestRuleArgs = {
  id: Scalars['UUID']['input'];
};


export type AuthorizedMutationDeletePhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type AuthorizedMutationSetCustomerPhoneNumbersArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type AuthorizedMutationSetDynamicTemplateIdArgs = {
  dynamicTemplateId?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizedMutationSetEudVerifiedArgs = {
  id: Scalars['UUID']['input'];
  verified: Scalars['Boolean']['input'];
};


export type AuthorizedMutationSetFeaturesArgs = {
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  features: Array<FeatureType>;
};


export type AuthorizedMutationSetTemplateTypeArgs = {
  params: SetTemplateTypeParamsInput;
};


export type AuthorizedMutationUpdateIngestRuleArgs = {
  id: Scalars['UUID']['input'];
  params: IngestRuleInfoInput;
};

export type Blockers = {
  isBlocked: Scalars['Boolean']['output'];
};

export enum Cm {
  Android = 'ANDROID',
  Email = 'EMAIL',
  Ios = 'IOS',
  Phone = 'PHONE',
  Sms = 'SMS',
  Webhook = 'WEBHOOK'
}

export type ClientPermissionEntry = {
  __typename?: 'ClientPermissionEntry';
  id: Scalars['UUID']['output'];
  permissions: Array<Permission>;
};

export type ClientPermissionNode = {
  __typename?: 'ClientPermissionNode';
  customer: Array<Permission>;
  group: Array<ClientPermissionEntry>;
  ipaws: Array<ClientPermissionEntry>;
  topic: Array<ClientPermissionEntry>;
};

export type CmOptionInput = {
  method: Cm;
};

export type CreateGeoFilterParametersInput = {
  boundary: Scalars['GeoPolygon']['input'];
  icon?: InputMaybe<Scalars['UUID']['input']>;
  layerId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGeoLayerParametersInput = {
  name: Scalars['String']['input'];
};

export type CreateGroupParametersInput = {
  internalJoinable: Scalars['Boolean']['input'];
  members: Array<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  parentGroupIds: Array<Scalars['UUID']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateIpawsCertInfoInput = {
  assignRoles?: InputMaybe<Array<CreateIpawsCertRoleInput>>;
  boundaries: Array<IpawsCertBoundaryInfoInput>;
  cogId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  keystoreAliasPassword: Scalars['String']['input'];
  keystoreB64: Scalars['String']['input'];
  keystorePassword: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: IpawsCertificateType;
};

export type CreateIpawsCertRoleInput = {
  roleId: Scalars['UUID']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};

export type CreateOptInUserParametersInput = {
  address?: InputMaybe<UserAddressInput>;
  customerId: Scalars['UUID']['input'];
  expiration?: InputMaybe<Scalars['Instant']['input']>;
  language: Language;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTopicParametersInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isCategory: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  parentId: Scalars['UUID']['input'];
};

export type CustomFieldNode = {
  __typename?: 'CustomFieldNode';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  type: CustomFieldType;
};

export type CustomFieldParameterInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  type: CustomFieldType;
};

export enum CustomFieldType {
  Choice = 'CHOICE',
  MultiLine = 'MULTI_LINE',
  SingleLine = 'SINGLE_LINE'
}

export type CustomerBlackoutPeriodInfoInput = {
  /** Minutes past midnight which the blackout period should end. */
  end: Scalars['Int']['input'];
  /** Minutes past midnight which the blackout period should start. */
  start: Scalars['Int']['input'];
};

export type CustomerBlackoutPeriodNode = {
  __typename?: 'CustomerBlackoutPeriodNode';
  /** Determines if the given instant falls between the blackout period */
  contains: Scalars['Boolean']['output'];
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};


export type CustomerBlackoutPeriodNodeContainsArgs = {
  time: Scalars['Instant']['input'];
};

export type CustomerNode = {
  __typename?: 'CustomerNode';
  blackoutPeriod?: Maybe<CustomerBlackoutPeriodNode>;
  boundary: Scalars['GeoPolygon']['output'];
  features: Array<FeatureType>;
  id: Scalars['UUID']['output'];
  languages: Array<Language>;
  name: Scalars['String']['output'];
  phoneNumbers: Array<PhoneNumberNode>;
  primaryColor: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
};

export type CustomizationInfoInput = {
  enabled: Scalars['Boolean']['input'];
  method: Cm;
  value: Scalars['String']['input'];
};

export type DraftInfoInput = {
  acknowledgable?: InputMaybe<Scalars['Boolean']['input']>;
  audience: AudienceInfoInput;
  duration?: InputMaybe<DurationInfoInput>;
  escalations: Array<EscalationInfoInput>;
  files: Array<Scalars['UUID']['input']>;
  locales: Array<LocaleInfoInput>;
  options: Array<CmOptionInput>;
  poll?: InputMaybe<PollInfoInput>;
  sender: Scalars['UUID']['input'];
  severity: MessageSeverity;
};

/** Configures how long a message should be active for. */
export type DurationInfoInput = {
  /** Absolute duration specifies a specific Instant. */
  absolute?: InputMaybe<Scalars['Instant']['input']>;
  /** A relative time equal to the execution time plus a given number of minutes. */
  span?: InputMaybe<Scalars['Int']['input']>;
};

export type DurationNode = {
  __typename?: 'DurationNode';
  absolute?: Maybe<Scalars['Instant']['output']>;
  span?: Maybe<Scalars['Int']['output']>;
};

export type EudNode = {
  __typename?: 'EUDNode';
  customer: CustomerNode;
  id: Scalars['UUID']['output'];
  invalidDate?: Maybe<Scalars['Instant']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['GeoPoint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Data pertaining to what this EUD has opted out from. */
  optOut: EudOptOutsNode;
  type: Cm;
  user: UserNode;
  value: Scalars['String']['output'];
};

export type EudOptOutsNode = {
  __typename?: 'EUDOptOutsNode';
  /** Those SMS phone numbers which this EUD has opted out from. */
  sms: Array<Scalars['String']['output']>;
  /** If this EUD has opted out of the SYSTEM sender. */
  system: Scalars['Boolean']['output'];
};

export type EmailAddressNode = {
  __typename?: 'EmailAddressNode';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type EmailAddressParamsInput = {
  email: Scalars['String']['input'];
};

export type EndUserDeviceParameterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support-only. Marks EUD as verified without sending a verification code to its owner. */
  overrideVerification?: InputMaybe<Scalars['Boolean']['input']>;
  sendVerification?: InputMaybe<Scalars['Boolean']['input']>;
  type: Cm;
  value: Scalars['String']['input'];
};

export type EndUserDeviceUpdateParameterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type EscalationInfoInput = {
  delaySec: Scalars['Int']['input'];
};

export type EscalationNode = {
  __typename?: 'EscalationNode';
  delaySec: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  priority: Scalars['Int']['output'];
};

export enum FeatureType {
  HasCmDeliveryOverrides = 'HAS_CM_DELIVERY_OVERRIDES',
  HasIpaws = 'HAS_IPAWS',
  HasOptInDuration = 'HAS_OPT_IN_DURATION',
  HasTopics = 'HAS_TOPICS',
  HasWebOptIn = 'HAS_WEB_OPT_IN'
}

export type FileNode = {
  __typename?: 'FileNode';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  preSigned: PreSignedFileNode;
  size: Scalars['Long']['output'];
  type: Scalars['String']['output'];
};

export type FipsNode = {
  __typename?: 'FipsNode';
  boundary: Scalars['GeoPolygon']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GeoFilterNode = {
  __typename?: 'GeoFilterNode';
  boundary: Scalars['GeoPolygon']['output'];
  icon?: Maybe<FileNode>;
  id: Scalars['UUID']['output'];
  layer: GeoLayerNode;
  name: Scalars['String']['output'];
  projectedUsersWithin: Scalars['Long']['output'];
};

export type GeoLayerArchiveBlockers = Blockers & {
  __typename?: 'GeoLayerArchiveBlockers';
  filters: Array<GeoFilterNode>;
  isBlocked: Scalars['Boolean']['output'];
};

export type GeoLayerNode = {
  __typename?: 'GeoLayerNode';
  blockers: GeoLayerArchiveBlockers;
  filters: Array<GeoFilterNode>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};


export type GeoLayerNodeFiltersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type GroupArchiveBlockers = Blockers & {
  __typename?: 'GroupArchiveBlockers';
  groups: Array<GroupNode>;
  isBlocked: Scalars['Boolean']['output'];
  senders: Array<SenderNode>;
};

export type GroupNode = {
  __typename?: 'GroupNode';
  aboutMembership: AboutMembershipNode;
  blockers: GroupArchiveBlockers;
  /** @deprecated Use `childrenPaged` instead */
  children: Array<GroupNode>;
  childrenPaged: Array<GroupNode>;
  id: Scalars['UUID']['output'];
  internalJoinable: Scalars['Boolean']['output'];
  /** @deprecated Use `aboutMembership` instead. */
  members: Array<UserNode>;
  /** @deprecated Use `aboutMembership` instead. */
  membersPaged: Array<UserNode>;
  name: Scalars['String']['output'];
  /** @deprecated User `parentsPaged` instead */
  parents: Array<GroupNode>;
  parentsPaged: Array<GroupNode>;
  senders: Array<SenderNode>;
  synchronized: Scalars['Boolean']['output'];
  templates: Array<TemplateNode>;
};


export type GroupNodeChildrenPagedArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type GroupNodeMembersPagedArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type GroupNodeParentsPagedArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type ImportEudInput = {
  type: Cm;
  value: Scalars['String']['input'];
};

export type ImportGroupInput = {
  name: Scalars['String']['input'];
  parentName: Scalars['String']['input'];
};

export type ImportGroupsResponseNode = {
  __typename?: 'ImportGroupsResponseNode';
  createdGroupCount: Scalars['Int']['output'];
  reusedGroupCount: Scalars['Int']['output'];
};

export type ImportUserInput = {
  address?: InputMaybe<UserAddressInput>;
  euds: Array<ImportEudInput>;
  /** Names of group memberships. Must match group name exactly. Only for full users (not opt-in). */
  groups: Array<Scalars['String']['input']>;
  /** Email used to sign it. Only for full users (not opt-in). Automatically included as EUD, don't specify in eud param as well */
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ImportUsersParametersInput = {
  autoVerifyEuds: Scalars['Boolean']['input'];
  importAsOptInUser: Scalars['Boolean']['input'];
  language?: InputMaybe<Language>;
  users: Array<ImportUserInput>;
};

export type ImportUsersResponseNode = {
  __typename?: 'ImportUsersResponseNode';
  emailEudCount: Scalars['Int']['output'];
  smsEudCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
  userCreationErrors: Array<UserCreationError>;
};

export type IngestNs = {
  __typename?: 'IngestNS';
  rules: Array<IngestRuleNode>;
};


export type IngestNsRulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type IngestRuleInfoInput = {
  destinationTemplateId: Scalars['UUID']['input'];
  matchExpr: Scalars['String']['input'];
  matchKey: Scalars['String']['input'];
};

export type IngestRuleNode = {
  __typename?: 'IngestRuleNode';
  destinationTemplate?: Maybe<TemplateNode>;
  id: Scalars['UUID']['output'];
  matchExpr: Scalars['String']['output'];
  matchKey: Scalars['String']['output'];
};

export type InsightsNode = {
  __typename?: 'InsightsNode';
  /** The total number of metrics that exist for a message which failed delivery, optionally filtered by a given CM */
  failedCount: Scalars['Long']['output'];
  /** Delivery analytics derived from the recipient method data associated with the message */
  metrics: Array<Metric>;
  /** The total number of metrics that exist for a message */
  metricsCount: Scalars['Long']['output'];
  /** The total number of metrics that exist for a message which have not been sent yet */
  pendingCount: Scalars['Long']['output'];
  /** The total number of metrics that exist for a message which are successful */
  successCount: Scalars['Long']['output'];
};


export type InsightsNodeMetricsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type Inspection = {
  __typename?: 'Inspection';
  expire?: Maybe<Scalars['Instant']['output']>;
  publish?: Maybe<Scalars['Instant']['output']>;
};

export type IpawsAlertNode = {
  __typename?: 'IpawsAlertNode';
  capMessage: IpawsCapMessageNode;
  certificate: IpawsCertNode;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  /** The IPAWS Response codes associated with this alert. May be null if the alert is not yet sent or if retrieval fails */
  response?: Maybe<Array<IpawsAlertResponseNode>>;
  serviceError?: Maybe<Scalars['String']['output']>;
  status: IpawsAlertStatus;
};

export type IpawsAlertResponseNode = {
  __typename?: 'IpawsAlertResponseNode';
  channel: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export enum IpawsAlertStatus {
  Cancel = 'CANCEL',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Received = 'RECEIVED',
  Template = 'TEMPLATE',
  Update = 'UPDATE'
}

export type IpawsCapMessageAddressNode = {
  __typename?: 'IpawsCapMessageAddressNode';
  id: Scalars['UUID']['output'];
  type: IpawsCapMessageAddressType;
  value: Scalars['String']['output'];
};

export enum IpawsCapMessageAddressType {
  CapexchCog = 'CAPEXCH_COG',
  General = 'GENERAL'
}

export type IpawsCapMessageInfoAreaCircleNode = {
  __typename?: 'IpawsCapMessageInfoAreaCircleNode';
  point: Scalars['GeoPoint']['output'];
  radius: Scalars['Float']['output'];
};

export type IpawsCapMessageInfoAreaNode = {
  __typename?: 'IpawsCapMessageInfoAreaNode';
  circles: Array<IpawsCapMessageInfoAreaCircleNode>;
  description: Scalars['String']['output'];
  geocodes: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  polygons: Array<Scalars['GeoPolygon']['output']>;
};

export enum IpawsCapMessageInfoCategory {
  Cbrne = 'CBRNE',
  Env = 'ENV',
  Fire = 'FIRE',
  Geo = 'GEO',
  Health = 'HEALTH',
  Infra = 'INFRA',
  Met = 'MET',
  Other = 'OTHER',
  Rescue = 'RESCUE',
  Safety = 'SAFETY',
  Security = 'SECURITY',
  Transport = 'TRANSPORT'
}

export enum IpawsCapMessageInfoCertainty {
  Likely = 'LIKELY',
  Observed = 'OBSERVED',
  Possible = 'POSSIBLE',
  Unknown = 'UNKNOWN',
  Unlikely = 'UNLIKELY'
}

export enum IpawsCapMessageInfoEasOrg {
  Civ = 'CIV',
  Eas = 'EAS',
  Pep = 'PEP',
  Wxr = 'WXR'
}

export type IpawsCapMessageInfoNode = {
  __typename?: 'IpawsCapMessageInfoNode';
  areas: Array<IpawsCapMessageInfoAreaNode>;
  audience?: Maybe<Scalars['String']['output']>;
  blockedChannels: Array<IpawsChannel>;
  categories: Array<IpawsCapMessageInfoCategory>;
  certainty: IpawsCapMessageInfoCertainty;
  cmamLongText?: Maybe<Scalars['String']['output']>;
  cmamText?: Maybe<Scalars['String']['output']>;
  contactInfo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  easOrg?: Maybe<IpawsCapMessageInfoEasOrg>;
  effective?: Maybe<Scalars['Instant']['output']>;
  event: Scalars['String']['output'];
  eventCodes: Array<Scalars['String']['output']>;
  expires?: Maybe<Scalars['Instant']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  onset?: Maybe<Scalars['Instant']['output']>;
  resources: Array<IpawsCapMessageInfoResourceNode>;
  responseTypes: Array<IpawsCapMessageInfoResponseType>;
  senderName?: Maybe<Scalars['String']['output']>;
  severity: IpawsCapMessageInfoSeverity;
  timezone?: Maybe<IpawsCapMessageInfoTzCode>;
  urgency: IpawsCapMessageInfoUrgency;
  weaHandling?: Maybe<IpawsCapMessageInfoWeaHandling>;
  web?: Maybe<Scalars['String']['output']>;
};

export type IpawsCapMessageInfoResourceNode = {
  __typename?: 'IpawsCapMessageInfoResourceNode';
  derefUri?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  digest?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};

export enum IpawsCapMessageInfoResponseType {
  AllClear = 'ALL_CLEAR',
  Assess = 'ASSESS',
  Avoid = 'AVOID',
  Evacuate = 'EVACUATE',
  Execute = 'EXECUTE',
  Monitor = 'MONITOR',
  None = 'NONE',
  Prepare = 'PREPARE',
  Shelter = 'SHELTER'
}

export enum IpawsCapMessageInfoSeverity {
  Extreme = 'EXTREME',
  Minor = 'MINOR',
  Moderate = 'MODERATE',
  Severe = 'SEVERE',
  Unknown = 'UNKNOWN'
}

export enum IpawsCapMessageInfoTzCode {
  Akst = 'AKST',
  Ast = 'AST',
  Chst = 'CHST',
  Cst = 'CST',
  Est = 'EST',
  Hst = 'HST',
  Mst = 'MST',
  Pst = 'PST',
  Sst = 'SST'
}

export enum IpawsCapMessageInfoUrgency {
  Expected = 'EXPECTED',
  Future = 'FUTURE',
  Immediate = 'IMMEDIATE',
  Past = 'PAST',
  Unknown = 'UNKNOWN'
}

export enum IpawsCapMessageInfoWeaHandling {
  ChildAbduction = 'CHILD_ABDUCTION',
  ImminentThreat = 'IMMINENT_THREAT',
  Presidential = 'PRESIDENTIAL',
  PublicSafety = 'PUBLIC_SAFETY',
  WeaTest = 'WEA_TEST'
}

export type IpawsCapMessageNode = {
  __typename?: 'IpawsCapMessageNode';
  addresses: Array<IpawsCapMessageAddressNode>;
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  incidents: Array<Scalars['String']['output']>;
  infos: Array<IpawsCapMessageInfoNode>;
  msgSource: Scalars['String']['output'];
  msgType: IpawsCapMessageType;
  note?: Maybe<Scalars['String']['output']>;
  references: Array<IpawsCapMessageReferenceNode>;
  restriction?: Maybe<Scalars['String']['output']>;
  scope: IpawsCapMessageScope;
  sender: Scalars['String']['output'];
  sent?: Maybe<Scalars['Instant']['output']>;
  status: IpawsCapMessageStatus;
};

export type IpawsCapMessageReferenceNode = {
  __typename?: 'IpawsCapMessageReferenceNode';
  capMessageReference?: Maybe<IpawsCapMessageNode>;
  id: Scalars['UUID']['output'];
  identifierReference: Scalars['String']['output'];
  senderReference: Scalars['String']['output'];
  sentReference: Scalars['Instant']['output'];
};

export enum IpawsCapMessageScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export enum IpawsCapMessageStatus {
  Actual = 'ACTUAL',
  Draft = 'DRAFT',
  Exercise = 'EXERCISE',
  System = 'SYSTEM',
  Test = 'TEST'
}

export enum IpawsCapMessageType {
  Ack = 'ACK',
  Alert = 'ALERT',
  Cancel = 'CANCEL',
  Error = 'ERROR',
  Update = 'UPDATE'
}

export type IpawsCertBoundaryInfoInput = {
  name: Scalars['String']['input'];
  polygon: Scalars['GeoPolygon']['input'];
};

export type IpawsCertBoundaryNode = {
  __typename?: 'IpawsCertBoundaryNode';
  cert: IpawsCertNode;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  polygon: Scalars['GeoPolygon']['output'];
};

export type IpawsCertChannelInfoInput = {
  channel: IpawsChannel;
  userEnabled: Scalars['Boolean']['input'];
};

export type IpawsCertChannelNode = {
  __typename?: 'IpawsCertChannelNode';
  cert: IpawsCertNode;
  channel: IpawsChannel;
  eventCodes: Array<IpawsEventCodeNode>;
  geoCodes: Array<FipsNode>;
  userEnabled: Scalars['Boolean']['output'];
};

export type IpawsCertNode = {
  __typename?: 'IpawsCertNode';
  /** Whether this certificate has been deemed active by IPAWS */
  active: Scalars['Boolean']['output'];
  blockers: IpawsCertNodeBlockers;
  boundaries: Array<IpawsCertBoundaryNode>;
  category: Scalars['String']['output'];
  channels: Array<IpawsCertChannelNode>;
  cogId: Scalars['Int']['output'];
  customer: CustomerNode;
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  /** Whether this certificate has been marked by the user as available for use within EMNS */
  enabled: Scalars['Boolean']['output'];
  /** The EventCodes associated with this Certificate which are active for the all the given channels. */
  eventCodes: Array<IpawsEventCodeNode>;
  expireAt: Scalars['Instant']['output'];
  expired: Scalars['Boolean']['output'];
  /** The GeoCodes associated with this Certificate which are active for the all the given channels. */
  geoCodes: Array<FipsNode>;
  id: Scalars['UUID']['output'];
  incomingAlertTemplate?: Maybe<TemplateNode>;
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  testSucceededAt: Scalars['Instant']['output'];
  type: IpawsCertificateType;
};


export type IpawsCertNodeEventCodesArgs = {
  channels: Array<IpawsChannel>;
};


export type IpawsCertNodeGeoCodesArgs = {
  channels: Array<IpawsChannel>;
};

export type IpawsCertNodeBlockers = Blockers & {
  __typename?: 'IpawsCertNodeBlockers';
  ipawsDraftAlerts: Array<IpawsAlertNode>;
  isBlocked: Scalars['Boolean']['output'];
};

export enum IpawsCertificateType {
  Live = 'LIVE',
  Test = 'TEST'
}

export enum IpawsChannel {
  Capexch = 'CAPEXCH',
  Cmas = 'CMAS',
  Eas = 'EAS',
  Nwem = 'NWEM',
  Public = 'PUBLIC'
}

export enum IpawsEventCode {
  Adr = 'ADR',
  Ava = 'AVA',
  Avw = 'AVW',
  Blu = 'BLU',
  Blz = 'BLZ',
  Cae = 'CAE',
  Cdw = 'CDW',
  Cem = 'CEM',
  Cfw = 'CFW',
  Dmo = 'DMO',
  Dsw = 'DSW',
  Ean = 'EAN',
  Eqw = 'EQW',
  Evi = 'EVI',
  Eww = 'EWW',
  Ffa = 'FFA',
  Ffs = 'FFS',
  Ffw = 'FFW',
  Fla = 'FLA',
  Flw = 'FLW',
  Frw = 'FRW',
  Hmw = 'HMW',
  Hua = 'HUA',
  Huw = 'HUW',
  Hww = 'HWW',
  Lae = 'LAE',
  Lew = 'LEW',
  Mep = 'MEP',
  Nic = 'NIC',
  Nmn = 'NMN',
  Npt = 'NPT',
  Nuw = 'NUW',
  Nws = 'NWS',
  Rhw = 'RHW',
  Rmt = 'RMT',
  Rwt = 'RWT',
  Smw = 'SMW',
  Sps = 'SPS',
  Spw = 'SPW',
  Ssa = 'SSA',
  Ssw = 'SSW',
  Svr = 'SVR',
  Svs = 'SVS',
  Toa = 'TOA',
  Toe = 'TOE',
  Tor = 'TOR',
  Tra = 'TRA',
  Trw = 'TRW',
  Tsw = 'TSW',
  Vow = 'VOW',
  Wsw = 'WSW'
}

export type IpawsEventCodeNode = {
  __typename?: 'IpawsEventCodeNode';
  channels: Array<IpawsChannel>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type IpawsMessageDataAreaCircleInput = {
  point: Scalars['GeoPoint']['input'];
  radius: Scalars['Float']['input'];
};

export type IpawsMessageDataAreaInput = {
  circles: Array<IpawsMessageDataAreaCircleInput>;
  codes: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  polygons: Array<Scalars['GeoPolygon']['input']>;
};

export type IpawsMessageDataContentInput = {
  contactInfo: Scalars['String']['input'];
  description: Scalars['String']['input'];
  easAudioFileId?: InputMaybe<Scalars['UUID']['input']>;
  headline: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  language: Language;
  wea?: InputMaybe<IpawsMessageDataContentWeaInput>;
};

export type IpawsMessageDataContentWeaInput = {
  longText: Scalars['String']['input'];
  shortText: Scalars['String']['input'];
};

export type IpawsMessageDataInput = {
  areas: Array<IpawsMessageDataAreaInput>;
  category: IpawsCapMessageInfoCategory;
  certId: Scalars['UUID']['input'];
  certainty: IpawsCapMessageInfoCertainty;
  channels: Array<IpawsChannel>;
  cogRecipients: Array<Scalars['Int']['input']>;
  contents: Array<IpawsMessageDataContentInput>;
  customerId: Scalars['UUID']['input'];
  durationMinutes: Scalars['Int']['input'];
  eventCode: IpawsEventCode;
  note?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<Scalars['String']['input']>;
  scope: IpawsCapMessageScope;
  severity: IpawsCapMessageInfoSeverity;
  status: IpawsMessageDataStatus;
  tz: IpawsCapMessageInfoTzCode;
  urgency: IpawsCapMessageInfoUrgency;
};

export enum IpawsMessageDataStatus {
  Actual = 'ACTUAL',
  Exercise = 'EXERCISE',
  Test = 'TEST'
}

export type IpawsTemplateNode = {
  __typename?: 'IpawsTemplateNode';
  /** The underlying alert template */
  alert: IpawsAlertNode;
  /** The user that initially created the template */
  creator?: Maybe<UserNode>;
  id: Scalars['UUID']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export type IpawsTemplatesSearchParametersInput = {
  environment?: InputMaybe<IpawsCertificateType>;
  eventCode?: InputMaybe<IpawsEventCode>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<IpawsTemplatesSortConfigInput>;
};

export type IpawsTemplatesSortConfigInput = {
  by: IpawsTemplatesSortOptions;
  direction: SortOrder;
};

export enum IpawsTemplatesSortOptions {
  Created = 'CREATED',
  EventCode = 'EVENT_CODE',
  LastModified = 'LAST_MODIFIED'
}

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum Language {
  Arabic = 'ARABIC',
  Bengali = 'BENGALI',
  Chinese = 'CHINESE',
  ChineseSimplified = 'CHINESE_SIMPLIFIED',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  Filipino = 'FILIPINO',
  French = 'FRENCH',
  German = 'GERMAN',
  Greek = 'GREEK',
  HaitianCreole = 'HAITIAN_CREOLE',
  Hebrew = 'HEBREW',
  Hindi = 'HINDI',
  Indonesian = 'INDONESIAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  Laotian = 'LAOTIAN',
  Nepali = 'NEPALI',
  Persian = 'PERSIAN',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  Russian = 'RUSSIAN',
  Somali = 'SOMALI',
  Spanish = 'SPANISH',
  Thai = 'THAI',
  Turkish = 'TURKISH',
  Ukrainian = 'UKRAINIAN',
  Urdu = 'URDU',
  Vietnamese = 'VIETNAMESE'
}

export type LocaleInfoInput = {
  body: Scalars['String']['input'];
  customizations?: InputMaybe<Array<CustomizationInfoInput>>;
  language: Language;
  richBody: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type MessageCmOptionNode = {
  __typename?: 'MessageCmOptionNode';
  id: Scalars['UUID']['output'];
  message: MessageNode;
  method: Cm;
};

/** A CM-specific customization of a given message body */
export type MessageCustomizationNode = {
  __typename?: 'MessageCustomizationNode';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  message: MessageNode;
  method: Cm;
  value: Scalars['String']['output'];
};

export type MessageLocaleNode = {
  __typename?: 'MessageLocaleNode';
  body: Scalars['String']['output'];
  customization?: Maybe<MessageCustomizationNode>;
  customizations: Array<MessageCustomizationNode>;
  id: Scalars['UUID']['output'];
  language: Language;
  richBody: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};


export type MessageLocaleNodeCustomizationArgs = {
  method: Cm;
};

export type MessageNode = {
  __typename?: 'MessageNode';
  about?: Maybe<About>;
  acknowledgable: Scalars['Boolean']['output'];
  audience: AudienceNode;
  body: Scalars['String']['output'];
  customizations: Array<MessageCustomizationNode>;
  duration?: Maybe<DurationNode>;
  escalations: Array<EscalationNode>;
  expireAt?: Maybe<Scalars['Instant']['output']>;
  files: Array<FileNode>;
  id: Scalars['UUID']['output'];
  insights: InsightsNode;
  /** Support only. Inspects active quartz jobs associated with this message. */
  jobs: Inspection;
  locale?: Maybe<MessageLocaleNode>;
  locales: Array<MessageLocaleNode>;
  notes: Array<MessageNode>;
  options: Array<MessageCmOptionNode>;
  poll?: Maybe<PollNode>;
  /** Projected delivery data based on the current audience state */
  projectedDelivery: ProjectedDeliveryNode;
  publishedAt?: Maybe<Scalars['Instant']['output']>;
  publishedBy?: Maybe<UserNode>;
  richBody: Scalars['String']['output'];
  scheduledFor?: Maybe<Scalars['Instant']['output']>;
  sender: SenderNode;
  severity: MessageSeverity;
  status: MessageStatus;
  subject: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
};


export type MessageNodeInsightsArgs = {
  cm?: InputMaybe<Cm>;
};


export type MessageNodeLocaleArgs = {
  language: Language;
};

export enum MessageSeverity {
  Critical = 'CRITICAL',
  Informational = 'INFORMATIONAL',
  Urgent = 'URGENT'
}

export enum MessageStatus {
  /** @deprecated Use MessageDAO::archive */
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Note = 'NOTE',
  Preview = 'PREVIEW',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
  Template = 'TEMPLATE'
}

export type Metric = {
  __typename?: 'Metric';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  cm: Cm;
  device: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  rawMetadataBlob?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Instant']['output']>;
  status: Status;
  user?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledge: Scalars['Boolean']['output'];
  acknowledgeByMessage: Scalars['Boolean']['output'];
  addEUD: EudNode;
  addGeoFilterToSender: SenderNode;
  addParentToGroup: GroupNode;
  addUserAddress: AddressNode;
  addUserToGroup: GroupNode;
  addUserToTopic: TopicNode;
  addUsersToGroup: GroupNode;
  addUsersToTopic: TopicNode;
  addWeatherZone: WeatherZoneNode;
  addWeatherZones: Array<WeatherZoneNode>;
  archiveGeoFilter: GeoFilterNode;
  archiveGeoLayer: GeoLayerNode;
  archiveGroup: GroupNode;
  archiveIpawsCertificate: IpawsCertNode;
  archiveIpawsTemplate: IpawsTemplateNode;
  archiveMessage: MessageNode;
  archiveSender: SenderNode;
  archiveTemplate: TemplateNode;
  archiveTopic: TopicNode;
  archiveUser: Scalars['Boolean']['output'];
  assignCustomerRole: UserRoleNode;
  assignGroupRole: UserRoleNode;
  assignIpawsRole: UserRoleNode;
  assignTopicRole: UserRoleNode;
  broadcastIpawsAlert: IpawsAlertNode;
  cancelIpawsAlert: IpawsAlertNode;
  cancelMessage: MessageNode;
  changeTopicParent: TopicNode;
  createAccessToken: WithToken;
  createCustomField: CustomFieldNode;
  createCustomer: CustomerNode;
  createDraft: MessageNode;
  createDraftIpawsAlert: IpawsAlertNode;
  createEmailAddress: Scalars['Boolean']['output'];
  createGeoFilter: GeoFilterNode;
  createGeoLayer: GeoLayerNode;
  createGroup: GroupNode;
  createIpawsCertificate: IpawsCertNode;
  createIpawsTemplate: IpawsTemplateNode;
  createIpawsTemplateFromAlert: IpawsTemplateNode;
  createNote: MessageNode;
  createOptInUser: UserNode;
  createRole: RoleNode;
  createSender: SenderNode;
  createTemplateFromMessage: TemplateNode;
  createTemplateV2: TemplateNode;
  createTopic: TopicNode;
  createUser: UserNode;
  deleteCustomField: Scalars['Boolean']['output'];
  deleteCustomer: Scalars['Boolean']['output'];
  deleteDraftIpawsAlert: IpawsAlertNode;
  deleteEmailAddress: Scalars['Boolean']['output'];
  deleteFile: Scalars['Boolean']['output'];
  /** @deprecated Use `archiveSender` instead */
  deleteSender: Scalars['Boolean']['output'];
  /** @deprecated Use archiveTemplate */
  deleteTemplate: TemplateNode;
  deleteWeatherZone: Scalars['Boolean']['output'];
  /** @deprecated Use archiveMessage */
  discardMessageDraft: MessageNode;
  duplicateIpawsTemplate: IpawsTemplateNode;
  duplicateTemplate: TemplateNode;
  expireAccessToken: AccessTokenNode;
  /** Reschedules a given PUBLISHED message to expire immediately. */
  expireMessage: MessageNode;
  importGroups: ImportGroupsResponseNode;
  importUsers: ImportUsersResponseNode;
  /** Queues a JSON object to be processed by the EMNS ingestion queue. */
  ingest: Scalars['Boolean']['output'];
  onboardUser: UserNode;
  removeEUD: Scalars['Boolean']['output'];
  removeGeoFilterFromSender: SenderNode;
  removeParentFromGroup: GroupNode;
  removeUserAddress: Scalars['Boolean']['output'];
  removeUserFromGroup: GroupNode;
  removeUserFromTopic: TopicNode;
  /** Specifies a new time for a given PUBLISHED message to expire at. */
  rescheduleMessageExpiration: MessageNode;
  resendEUDVerificationCode: EudNode;
  resendUserInvites: Array<UserNode>;
  scheduleMessage: MessageNode;
  sendEudLoginCode: Scalars['Boolean']['output'];
  sendMessage: MessageNode;
  sendPreview: MessageNode;
  sendTemplate: MessageNode;
  setCustomerBlackoutPeriod: CustomerNode;
  setDefaultEud: EudNode;
  setGeoFiltersForSender: SenderNode;
  setUserCustomField: UserCustomFieldNode;
  submitPollResponse: PollResponseNode;
  /** Support-only mutations. */
  support: AuthorizedMutation;
  unassignRole: UserNode;
  unscheduleMessage: MessageNode;
  updateCustomerColor: CustomerNode;
  updateCustomerIcon: CustomerNode;
  updateCustomerLanguages: CustomerNode;
  updateDraft: MessageNode;
  updateDraftIpawsAlert: IpawsAlertNode;
  updateEUD: EudNode;
  updateEudName: EudNode;
  updateGeoFilter: GeoFilterNode;
  updateGeoLayer: GeoLayerNode;
  updateGroup: GroupNode;
  updateIpawsAlert: IpawsAlertNode;
  updateIpawsCertificate: IpawsCertNode;
  updateRolePermissions: RoleNode;
  updateSender: SenderNode;
  updateTopic: TopicNode;
  updateUser: UserNode;
  updateUserAddress: AddressNode;
  verifyEUD: EudNode;
  verifyEudLoginCode: UserNode;
};


export type MutationAcknowledgeArgs = {
  recipientMethodId: Scalars['UUID']['input'];
};


export type MutationAcknowledgeByMessageArgs = {
  messageId: Scalars['UUID']['input'];
};


export type MutationAddEudArgs = {
  eudParams: EndUserDeviceParameterInput;
  userId: Scalars['UUID']['input'];
};


export type MutationAddGeoFilterToSenderArgs = {
  filterId: Scalars['UUID']['input'];
  senderId: Scalars['UUID']['input'];
};


export type MutationAddParentToGroupArgs = {
  groupId: Scalars['UUID']['input'];
  parentId: Scalars['UUID']['input'];
};


export type MutationAddUserAddressArgs = {
  address: UserAddressInput;
  userId: Scalars['UUID']['input'];
};


export type MutationAddUserToGroupArgs = {
  groupId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationAddUserToTopicArgs = {
  topicId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationAddUsersToGroupArgs = {
  groupId: Scalars['UUID']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};


export type MutationAddUsersToTopicArgs = {
  topicId: Scalars['UUID']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};


export type MutationAddWeatherZoneArgs = {
  wz: WeatherZoneParametersInput;
};


export type MutationAddWeatherZonesArgs = {
  wz: WeatherZonesParametersInput;
};


export type MutationArchiveGeoFilterArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveGeoLayerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveGroupArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveIpawsCertificateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveIpawsTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveMessageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveSenderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveTopicArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type MutationAssignCustomerRoleArgs = {
  params: AssignCustomerRoleParamsInput;
};


export type MutationAssignGroupRoleArgs = {
  params: AssignGroupRoleParamsInput;
};


export type MutationAssignIpawsRoleArgs = {
  params: AssignIpawsRoleParamsInput;
};


export type MutationAssignTopicRoleArgs = {
  params: AssignTopicRoleParamsInput;
};


export type MutationBroadcastIpawsAlertArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCancelIpawsAlertArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCancelMessageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationChangeTopicParentArgs = {
  id: Scalars['UUID']['input'];
  parentId: Scalars['UUID']['input'];
};


export type MutationCreateAccessTokenArgs = {
  params: AccessTokenInfoInput;
};


export type MutationCreateCustomFieldArgs = {
  cf: CustomFieldParameterInput;
};


export type MutationCreateCustomerArgs = {
  adminEmail: Scalars['String']['input'];
  boundary: Scalars['GeoPolygon']['input'];
  dynamicEmailTemplateId?: InputMaybe<Scalars['String']['input']>;
  emailApiKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneProvider: PhoneProvider;
  primaryColor: Scalars['String']['input'];
  registrationEnabled: Scalars['Boolean']['input'];
  sendFromEmail: Scalars['String']['input'];
  sendFromPhone: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
  telnyxProfileId?: InputMaybe<Scalars['String']['input']>;
  telnyxVoiceId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['TimeZone']['input'];
  twilioAuthToken?: InputMaybe<Scalars['String']['input']>;
  twilioSid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDraftArgs = {
  params: DraftInfoInput;
};


export type MutationCreateDraftIpawsAlertArgs = {
  message: IpawsMessageDataInput;
};


export type MutationCreateEmailAddressArgs = {
  params: EmailAddressParamsInput;
};


export type MutationCreateGeoFilterArgs = {
  parameters: CreateGeoFilterParametersInput;
};


export type MutationCreateGeoLayerArgs = {
  parameters: CreateGeoLayerParametersInput;
};


export type MutationCreateGroupArgs = {
  params: CreateGroupParametersInput;
};


export type MutationCreateIpawsCertificateArgs = {
  params: CreateIpawsCertInfoInput;
};


export type MutationCreateIpawsTemplateArgs = {
  alertId: Scalars['UUID']['input'];
};


export type MutationCreateIpawsTemplateFromAlertArgs = {
  alertId: Scalars['UUID']['input'];
};


export type MutationCreateNoteArgs = {
  id: Scalars['UUID']['input'];
  locales: Array<NoteLocaleInfoInput>;
};


export type MutationCreateOptInUserArgs = {
  params: CreateOptInUserParametersInput;
};


export type MutationCreateRoleArgs = {
  params: RoleParamsInput;
};


export type MutationCreateSenderArgs = {
  params: SenderInfoInput;
};


export type MutationCreateTemplateFromMessageArgs = {
  msgId: Scalars['UUID']['input'];
};


export type MutationCreateTemplateV2Args = {
  info: TemplateInfoV2Input;
};


export type MutationCreateTopicArgs = {
  params: CreateTopicParametersInput;
};


export type MutationCreateUserArgs = {
  address?: InputMaybe<UserAddressInput>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCustomFieldArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDraftIpawsAlertArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteEmailAddressArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSenderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteWeatherZoneArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDiscardMessageDraftArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDuplicateIpawsTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDuplicateTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationExpireAccessTokenArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationExpireMessageArgs = {
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportGroupsArgs = {
  groups: Array<ImportGroupInput>;
};


export type MutationImportUsersArgs = {
  data: ImportUsersParametersInput;
};


export type MutationIngestArgs = {
  json: Scalars['String']['input'];
};


export type MutationOnboardUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveEudArgs = {
  eudId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationRemoveGeoFilterFromSenderArgs = {
  filterId: Scalars['UUID']['input'];
  senderId: Scalars['UUID']['input'];
};


export type MutationRemoveParentFromGroupArgs = {
  groupId: Scalars['UUID']['input'];
  parentId: Scalars['UUID']['input'];
};


export type MutationRemoveUserAddressArgs = {
  addressId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationRemoveUserFromGroupArgs = {
  groupId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationRemoveUserFromTopicArgs = {
  topicId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationRescheduleMessageExpirationArgs = {
  duration: DurationInfoInput;
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendEudVerificationCodeArgs = {
  eudId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationResendUserInvitesArgs = {
  userIds: Array<Scalars['UUID']['input']>;
};


export type MutationScheduleMessageArgs = {
  id: Scalars['UUID']['input'];
  sendAt: Scalars['Instant']['input'];
};


export type MutationSendEudLoginCodeArgs = {
  params: SendEudLoginCodeParamsInput;
};


export type MutationSendMessageArgs = {
  expireAt?: InputMaybe<Scalars['Instant']['input']>;
  id: Scalars['UUID']['input'];
};


export type MutationSendPreviewArgs = {
  cms: Array<Cm>;
  params: DraftInfoInput;
};


export type MutationSendTemplateArgs = {
  id: Scalars['UUID']['input'];
  replacements: Array<KeyValueInput>;
};


export type MutationSetCustomerBlackoutPeriodArgs = {
  params?: InputMaybe<CustomerBlackoutPeriodInfoInput>;
};


export type MutationSetDefaultEudArgs = {
  eudId: Scalars['UUID']['input'];
  isDefault: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationSetGeoFiltersForSenderArgs = {
  filterIds: Array<Scalars['UUID']['input']>;
  senderId: Scalars['UUID']['input'];
};


export type MutationSetUserCustomFieldArgs = {
  ucf: UserCustomFieldParametersInput;
  userId: Scalars['UUID']['input'];
};


export type MutationSubmitPollResponseArgs = {
  method?: InputMaybe<Cm>;
  optionId: Scalars['UUID']['input'];
  pollId: Scalars['UUID']['input'];
};


export type MutationUnassignRoleArgs = {
  userId: Scalars['UUID']['input'];
  userRoleId: Scalars['UUID']['input'];
};


export type MutationUnscheduleMessageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUpdateCustomerColorArgs = {
  primaryColor: Scalars['String']['input'];
};


export type MutationUpdateCustomerIconArgs = {
  iconId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUpdateCustomerLanguagesArgs = {
  id: Scalars['UUID']['input'];
  languages: Array<Language>;
};


export type MutationUpdateDraftArgs = {
  id: Scalars['UUID']['input'];
  params: DraftInfoInput;
};


export type MutationUpdateDraftIpawsAlertArgs = {
  id: Scalars['UUID']['input'];
  message: IpawsMessageDataInput;
};


export type MutationUpdateEudArgs = {
  eudId: Scalars['UUID']['input'];
  eudParams: EndUserDeviceUpdateParameterInput;
  userId: Scalars['UUID']['input'];
};


export type MutationUpdateEudNameArgs = {
  eudId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationUpdateGeoFilterArgs = {
  id: Scalars['UUID']['input'];
  parameters: CreateGeoFilterParametersInput;
};


export type MutationUpdateGeoLayerArgs = {
  id: Scalars['UUID']['input'];
  parameters: CreateGeoLayerParametersInput;
};


export type MutationUpdateGroupArgs = {
  id: Scalars['UUID']['input'];
  params: UpdateGroupParametersInput;
};


export type MutationUpdateIpawsAlertArgs = {
  id: Scalars['UUID']['input'];
  update: IpawsMessageDataInput;
};


export type MutationUpdateIpawsCertificateArgs = {
  id: Scalars['UUID']['input'];
  params: UpdateIpawsCertInfoInput;
};


export type MutationUpdateRolePermissionsArgs = {
  params: UpdateRoleParametersInput;
};


export type MutationUpdateSenderArgs = {
  id: Scalars['UUID']['input'];
  params: UpdateSenderParametersInput;
};


export type MutationUpdateTopicArgs = {
  id: Scalars['UUID']['input'];
  params: UpdateTopicParametersInput;
};


export type MutationUpdateUserArgs = {
  params: UpdateUserParametersInput;
  userId: Scalars['UUID']['input'];
};


export type MutationUpdateUserAddressArgs = {
  address: UserAddressInput;
  addressId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationVerifyEudArgs = {
  eudId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationVerifyEudLoginCodeArgs = {
  params: VerifyEudLoginCodeParamsInput;
};

export type NoteLocaleInfoInput = {
  body: Scalars['String']['input'];
  language: Language;
  richBody: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type OptInUserMetricsResults = {
  __typename?: 'OptInUserMetricsResults';
  activeEmailCount: Scalars['Long']['output'];
  activeOptInUsersCount: Scalars['Long']['output'];
  activePhoneNumberCount: Scalars['Long']['output'];
};

export type OptInUserSearchParametersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OptionInfoInput = {
  content: Scalars['String']['input'];
};

export enum Permission {
  CustomerAuditView = 'CUSTOMER_AUDIT_VIEW',
  CustomerBoundaryManage = 'CUSTOMER_BOUNDARY_MANAGE',
  CustomerBrandingManage = 'CUSTOMER_BRANDING_MANAGE',
  CustomerErpManage = 'CUSTOMER_ERP_MANAGE',
  CustomerIpawsManage = 'CUSTOMER_IPAWS_MANAGE',
  CustomerIpawsSend = 'CUSTOMER_IPAWS_SEND',
  CustomerReportsView = 'CUSTOMER_REPORTS_VIEW',
  CustomerRolesManage = 'CUSTOMER_ROLES_MANAGE',
  CustomerSettingsManage = 'CUSTOMER_SETTINGS_MANAGE',
  CustomerSetTopicRequired = 'CUSTOMER_SET_TOPIC_REQUIRED',
  CustomerShapeManage = 'CUSTOMER_SHAPE_MANAGE',
  CustomerUsersCreate = 'CUSTOMER_USERS_CREATE',
  CustomerUsersDelete = 'CUSTOMER_USERS_DELETE',
  CustomerUsersUpdate = 'CUSTOMER_USERS_UPDATE',
  GroupAnalyticsView = 'GROUP_ANALYTICS_VIEW',
  GroupCallerIdManage = 'GROUP_CALLER_ID_MANAGE',
  GroupLocationManage = 'GROUP_LOCATION_MANAGE',
  GroupMessageApprove = 'GROUP_MESSAGE_APPROVE',
  GroupMessageCancel = 'GROUP_MESSAGE_CANCEL',
  GroupMessageSchedule = 'GROUP_MESSAGE_SCHEDULE',
  GroupMessageSendFrom = 'GROUP_MESSAGE_SEND_FROM',
  GroupMessageSendTo = 'GROUP_MESSAGE_SEND_TO',
  GroupPollResponseCreate = 'GROUP_POLL_RESPONSE_CREATE',
  GroupPollResponseView = 'GROUP_POLL_RESPONSE_VIEW',
  GroupRolesManage = 'GROUP_ROLES_MANAGE',
  GroupSenderManage = 'GROUP_SENDER_MANAGE',
  GroupSubgroupManage = 'GROUP_SUBGROUP_MANAGE',
  GroupTemplateCreate = 'GROUP_TEMPLATE_CREATE',
  GroupTemplateDelete = 'GROUP_TEMPLATE_DELETE',
  GroupTemplateUpdate = 'GROUP_TEMPLATE_UPDATE',
  GroupUsersManage = 'GROUP_USERS_MANAGE',
  GroupUsersView = 'GROUP_USERS_VIEW',
  GroupVoiceGreetingManage = 'GROUP_VOICE_GREETING_MANAGE',
  GroupVoicePreRecordedManage = 'GROUP_VOICE_PRE_RECORDED_MANAGE',
  IpawsAlertModify = 'IPAWS_ALERT_MODIFY',
  IpawsHistoryView = 'IPAWS_HISTORY_VIEW',
  IpawsMessageCancel = 'IPAWS_MESSAGE_CANCEL',
  IpawsMessageSend = 'IPAWS_MESSAGE_SEND',
  IpawsMessageUpdate = 'IPAWS_MESSAGE_UPDATE',
  IpawsProfileView = 'IPAWS_PROFILE_VIEW',
  TopicCategoryManage = 'TOPIC_CATEGORY_MANAGE',
  TopicMessageSendTo = 'TOPIC_MESSAGE_SEND_TO',
  TopicRolesManage = 'TOPIC_ROLES_MANAGE',
  TopicUsersManage = 'TOPIC_USERS_MANAGE',
  TopicUsersView = 'TOPIC_USERS_VIEW'
}

export type PermissionNode = {
  __typename?: 'PermissionNode';
  description: Scalars['String']['output'];
  id: Permission;
  name: Scalars['String']['output'];
  type: PermissionType;
};

export enum PermissionType {
  Customer = 'CUSTOMER',
  Group = 'GROUP',
  Ipaws = 'IPAWS',
  Topic = 'TOPIC'
}

export type PhoneNumberNode = {
  __typename?: 'PhoneNumberNode';
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export enum PhoneProvider {
  Telnyx = 'TELNYX',
  Twilio = 'TWILIO'
}

export type PollInfoInput = {
  content: Scalars['String']['input'];
  options: Array<OptionInfoInput>;
};

export type PollInsightsCountNode = {
  __typename?: 'PollInsightsCountNode';
  count: Scalars['Int']['output'];
  option: PollOptionNode;
};

export type PollInsightsNode = {
  __typename?: 'PollInsightsNode';
  counts: Array<PollInsightsCountNode>;
  responses: Array<PollResponseNode>;
};


export type PollInsightsNodeResponsesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  optionId: Scalars['UUID']['input'];
};

export type PollNode = {
  __typename?: 'PollNode';
  content: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  insights: PollInsightsNode;
  options: Array<PollOptionNode>;
};

export type PollOptionNode = {
  __typename?: 'PollOptionNode';
  content: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isSelected: Scalars['Boolean']['output'];
};

export type PollResponseNode = {
  __typename?: 'PollResponseNode';
  id: Scalars['UUID']['output'];
  /** The CM associated with this response. If null, implies a WEB origin. */
  method?: Maybe<Cm>;
  recordedAt: Scalars['Instant']['output'];
  user: UserNode;
};

export type PreSignedFileNode = {
  __typename?: 'PreSignedFileNode';
  expirationDate: Scalars['Instant']['output'];
  id: Scalars['UUID']['output'];
};

export type ProjectedDeliveryNode = {
  __typename?: 'ProjectedDeliveryNode';
  /** The number of projected deliveries via a given CM */
  deliveryCount: Scalars['Int']['output'];
  /** The total projected number of deliveries, not deduplicated by user */
  totalDeliveryCount: Scalars['Int']['output'];
  /** The total projected number of unique users which will be delivered a notification */
  uniqueUserCount: Scalars['Int']['output'];
};


export type ProjectedDeliveryNodeDeliveryCountArgs = {
  cm: Cm;
};

export type Query = {
  __typename?: 'Query';
  clientPermissions: ClientPermissionNode;
  customFields: Array<CustomFieldNode>;
  customer: CustomerNode;
  customers: Array<CustomerNode>;
  /** Projects theoretical delivery count for the given Draft input */
  deliveryProjection: ProjectedDeliveryNode;
  drafts: Array<MessageNode>;
  file: FileNode;
  fipsData: FipsNode;
  geoFilter: GeoFilterNode;
  /** @deprecated Use `geoLayers` instead */
  geoFilters: Array<GeoFilterNode>;
  /** @deprecated Use `geoLayers` instead */
  geoFiltersWithin: Array<GeoFilterNode>;
  geoLayer: GeoLayerNode;
  geoLayers: Array<GeoLayerNode>;
  getAvailableEmails: Array<EmailAddressNode>;
  getAvailablePhoneNumbers: Array<Scalars['String']['output']>;
  getEUD: EudNode;
  /** @deprecated Use getUserEUDs instead */
  getEUDs: Array<EudNode>;
  getUserEUDs: Array<EudNode>;
  group: GroupNode;
  /**
   *
   *         Those messages which have been sent and which the user is a recipient of
   *
   */
  inbox: Array<MessageNode>;
  ingest: IngestNs;
  ipawsAlert: IpawsAlertNode;
  ipawsAlerts: Array<IpawsAlertNode>;
  ipawsCertificate: IpawsCertNode;
  ipawsCertificates: Array<IpawsCertNode>;
  ipawsTemplate: IpawsTemplateNode;
  ipawsTemplates: Array<IpawsTemplateNode>;
  message: MessageNode;
  now: TimeNode;
  optInUserMetrics: OptInUserMetricsResults;
  optInUsers: Array<UserNode>;
  permission: PermissionNode;
  permissions: Array<PermissionNode>;
  /** Renders the given message info as SMS content */
  renderDraftAsSMS: Scalars['String']['output'];
  role: RoleNode;
  roles: Array<RoleNode>;
  rootGroup: GroupNode;
  rootTopic: TopicNode;
  scheduled: Array<MessageNode>;
  searchGroups: Array<GroupNode>;
  self: UserNode;
  sender: SenderNode;
  senders: Array<SenderNode>;
  sent: Array<MessageNode>;
  support: SupportNode;
  template: TemplateNode;
  /** Templates belonging to any group which the user can send from */
  templates: Array<TemplateNode>;
  topic: TopicNode;
  user: UserNode;
  users: Array<UserNode>;
  /** Validates the given polygons against the IPAWS CAP getPolygonValidity check */
  validateIpawsAlertBoundary: ValidateIpawsAlertBoundaryNode;
  weatherZones: Array<WeatherZoneNode>;
};


export type QueryCustomerArgs = {
  subDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeliveryProjectionArgs = {
  info: DraftInfoInput;
};


export type QueryDraftsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryFileArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryFipsDataArgs = {
  code: Scalars['String']['input'];
};


export type QueryGeoFilterArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGeoFiltersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGeoFiltersWithinArgs = {
  within: Scalars['GeoPolygon']['input'];
};


export type QueryGeoLayerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGeoLayersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetEudArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetUserEuDsArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryGroupArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryInboxArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<MessageStatus>;
};


export type QueryIpawsAlertArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryIpawsAlertsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<Array<IpawsAlertStatus>>;
};


export type QueryIpawsCertificateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryIpawsCertificatesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIpawsTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryIpawsTemplatesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<IpawsTemplatesSearchParametersInput>;
};


export type QueryMessageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOptInUsersArgs = {
  filters?: InputMaybe<OptInUserSearchParametersInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryPermissionArgs = {
  id: Permission;
};


export type QueryPermissionsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryRenderDraftAsSmsArgs = {
  info: DraftInfoInput;
};


export type QueryRoleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRolesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryScheduledArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerySearchGroupsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  permissions: Array<Permission>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySenderArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySentArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTemplatesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<TemplatesSearchParametersInput>;
};


export type QueryTopicArgs = {
  topicId: Scalars['UUID']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryUsersArgs = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupless?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  nameQuery?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<UserStatus>;
};


export type QueryValidateIpawsAlertBoundaryArgs = {
  params: ValidateIpawsAlertBoundaryParamsInput;
};

export type RoleNode = {
  __typename?: 'RoleNode';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionNode>;
  type: PermissionType;
};

export type RoleParamsInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissions: Array<Permission>;
  type: PermissionType;
};

export type SendEudLoginCodeParamsInput = {
  customerId: Scalars['UUID']['input'];
  type: Cm;
  value: Scalars['String']['input'];
};

export type SenderBlockers = Blockers & {
  __typename?: 'SenderBlockers';
  isBlocked: Scalars['Boolean']['output'];
  messages: Array<MessageNode>;
  templates: Array<TemplateNode>;
};

export type SenderInfoInput = {
  emailFooter?: InputMaybe<Scalars['UUID']['input']>;
  emailHeader?: InputMaybe<Scalars['UUID']['input']>;
  fromEmail: Scalars['String']['input'];
  fromPhone: Scalars['String']['input'];
  group: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  verificationSender?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SenderNode = {
  __typename?: 'SenderNode';
  blockers: SenderBlockers;
  boundary?: Maybe<Scalars['GeoMultiPolygon']['output']>;
  customer: CustomerNode;
  emailFooter?: Maybe<Scalars['String']['output']>;
  emailHeader?: Maybe<Scalars['String']['output']>;
  filters: Array<GeoFilterNode>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  fromPhone?: Maybe<Scalars['String']['output']>;
  group: GroupNode;
  id: Scalars['UUID']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  projectedUsersWithin: Scalars['Long']['output'];
  verificationSender: Scalars['Boolean']['output'];
};


export type SenderNodeFiltersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type SenderNodeProjectedUsersWithinArgs = {
  within: Scalars['GeoMultiPolygon']['input'];
};

export type SetTemplateTypeParamsInput = {
  id: Scalars['UUID']['input'];
  type: TemplateType;
};

export type SmsOptOutNode = {
  __typename?: 'SmsOptOutNode';
  createdAt: Scalars['Instant']['output'];
  euds: Array<EudNode>;
  id: Scalars['UUID']['output'];
  recipientPhoneNumber?: Maybe<Scalars['String']['output']>;
  senderPhoneNumber: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export enum Status {
  Fail = 'Fail',
  Ok = 'Ok',
  Pending = 'Pending'
}

export type Subscription = {
  __typename?: 'Subscription';
  inbox: Array<MessageNode>;
  now: TimeNode;
};


export type SubscriptionInboxArgs = {
  limit: Scalars['Int']['input'];
};

export type SupportNode = {
  __typename?: 'SupportNode';
  /** @deprecated Use UserQuery optInUsers instead */
  optInUsers: Array<UserNode>;
  /** All phone numbers available to be assigned to customers, regardless of twilio SID */
  phoneNumbers: Array<PhoneNumberNode>;
  smsOptOut: SmsOptOutNode;
  smsOptOuts: Array<SmsOptOutNode>;
};


export type SupportNodeOptInUsersArgs = {
  filters?: InputMaybe<OptInUserSearchParametersInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type SupportNodeSmsOptOutArgs = {
  recipientPhoneNumber: Scalars['String']['input'];
  senderPhoneNumber: Scalars['String']['input'];
};


export type SupportNodeSmsOptOutsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Long']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateInfoV2Input = {
  message: DraftInfoInput;
};

export type TemplateNode = {
  __typename?: 'TemplateNode';
  createdAt: Scalars['Instant']['output'];
  /** The user that initially created the template */
  creator?: Maybe<UserNode>;
  id: Scalars['UUID']['output'];
  /** The underlying message template */
  message: MessageNode;
  /** The owning group of the template */
  owner: GroupNode;
  type: TemplateType;
  updatedAt: Scalars['Instant']['output'];
};

export enum TemplateType {
  Customer = 'CUSTOMER',
  Ipaws = 'IPAWS',
  OptIn = 'OPT_IN',
  Welcome = 'WELCOME'
}

export type TemplatesSearchParametersInput = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<MessageSeverity>;
  sort?: InputMaybe<TemplatesSortConfigInput>;
};

export type TemplatesSortConfigInput = {
  by: TemplatesSortOptions;
  direction: SortOrder;
};

export enum TemplatesSortOptions {
  Created = 'CREATED',
  LastModified = 'LAST_MODIFIED',
  Subject = 'SUBJECT'
}

export type TimeNode = {
  __typename?: 'TimeNode';
  now: Scalars['String']['output'];
  ts: Scalars['Long']['output'];
};

export type TopicArchiveBlockers = Blockers & {
  __typename?: 'TopicArchiveBlockers';
  isBlocked: Scalars['Boolean']['output'];
  topics: Array<TopicNode>;
};

export type TopicNode = {
  __typename?: 'TopicNode';
  aboutMembership: AboutMembershipNode;
  blockers: TopicArchiveBlockers;
  children: Array<TopicNode>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isCategory: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  /** @deprecated Use `aboutMembership` instead */
  members: Array<UserNode>;
  /** @deprecated Use `aboutMembership` instead */
  membersPaged: Array<UserNode>;
  name: Scalars['String']['output'];
  parent?: Maybe<TopicNode>;
};


export type TopicNodeMembersPagedArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type UpdateGroupParametersInput = {
  internalJoinable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateIpawsCertInfoInput = {
  boundaries: Array<IpawsCertBoundaryInfoInput>;
  channels: Array<IpawsCertChannelInfoInput>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateRoleParametersInput = {
  permissions: Array<Permission>;
  roleId: Scalars['UUID']['input'];
};

export type UpdateSenderParametersInput = {
  fromEmailAddress: Scalars['String']['input'];
  fromPhone: Scalars['String']['input'];
  group?: InputMaybe<Scalars['UUID']['input']>;
  /** Support-only. Denotes this sender as the system sender to be used for automated messages. */
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  verificationSender: Scalars['Boolean']['input'];
};

export type UpdateTopicParametersInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateUserParametersInput = {
  language: Language;
  name: Scalars['String']['input'];
};

export type UserAddressInput = {
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type UserCreationError = {
  __typename?: 'UserCreationError';
  error: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserCustomFieldNode = {
  __typename?: 'UserCustomFieldNode';
  customField: CustomFieldNode;
  id: Scalars['UUID']['output'];
  value: Scalars['String']['output'];
};

export type UserCustomFieldParametersInput = {
  customFieldId: Scalars['UUID']['input'];
  value: Scalars['String']['input'];
};

export type UserNode = {
  __typename?: 'UserNode';
  accessTokens: Array<AccessTokenNode>;
  addresses: Array<AddressNode>;
  clientPermissions: ClientPermissionNode;
  /** Those CMs which the user has at least one active EUD for. */
  cms: Array<Cm>;
  customFields: Array<UserCustomFieldNode>;
  euds: Array<EudNode>;
  expiration?: Maybe<Scalars['Instant']['output']>;
  groups: Array<GroupNode>;
  id: Scalars['UUID']['output'];
  /** @deprecated Use status instead */
  isOnboarded: Scalars['Boolean']['output'];
  language: Language;
  lastLogin?: Maybe<Scalars['Instant']['output']>;
  loginEmail?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<UserRoleNode>;
  status: UserStatus;
  statusSince: Scalars['Instant']['output'];
  topics: Array<TopicNode>;
};

export type UserRoleNode = {
  __typename?: 'UserRoleNode';
  group?: Maybe<GroupNode>;
  id: Scalars['UUID']['output'];
  ipawsCert?: Maybe<IpawsCertNode>;
  role: RoleNode;
  topic?: Maybe<TopicNode>;
  user: UserNode;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  OptIn = 'OPT_IN'
}

export type ValidateIpawsAlertBoundaryDetailsNode = {
  __typename?: 'ValidateIpawsAlertBoundaryDetailsNode';
  errorCodes: Array<Scalars['String']['output']>;
  polygon: Scalars['GeoPolygon']['output'];
  success: Scalars['Boolean']['output'];
};

export type ValidateIpawsAlertBoundaryNode = {
  __typename?: 'ValidateIpawsAlertBoundaryNode';
  details: Array<ValidateIpawsAlertBoundaryDetailsNode>;
  success: Scalars['Boolean']['output'];
};

export type ValidateIpawsAlertBoundaryParamsInput = {
  boundary: Array<Scalars['GeoPolygon']['input']>;
  certId: Scalars['UUID']['input'];
};

export type VerifyEudLoginCodeParamsInput = {
  customerId: Scalars['UUID']['input'];
  type: Cm;
  value: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type WeatherZoneNode = {
  __typename?: 'WeatherZoneNode';
  id: Scalars['UUID']['output'];
  sender: SenderNode;
  topic: TopicNode;
  zoneId: Scalars['String']['output'];
};

export type WeatherZoneParametersInput = {
  senderId: Scalars['UUID']['input'];
  topicId: Scalars['UUID']['input'];
  zoneId: Scalars['String']['input'];
};

export type WeatherZonesParametersInput = {
  senderId: Scalars['UUID']['input'];
  topicId: Scalars['UUID']['input'];
  zoneIds: Array<Scalars['String']['input']>;
};

export type WithToken = {
  __typename?: 'WithToken';
  expiration?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['UUID']['output'];
  isExpired: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['Instant']['output']>;
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};


type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const CmSchema = z.nativeEnum(Cm);

export const CustomFieldTypeSchema = z.nativeEnum(CustomFieldType);

export const FeatureTypeSchema = z.nativeEnum(FeatureType);

export const IpawsAlertStatusSchema = z.nativeEnum(IpawsAlertStatus);

export const IpawsCapMessageAddressTypeSchema = z.nativeEnum(IpawsCapMessageAddressType);

export const IpawsCapMessageInfoCategorySchema = z.nativeEnum(IpawsCapMessageInfoCategory);

export const IpawsCapMessageInfoCertaintySchema = z.nativeEnum(IpawsCapMessageInfoCertainty);

export const IpawsCapMessageInfoEasOrgSchema = z.nativeEnum(IpawsCapMessageInfoEasOrg);

export const IpawsCapMessageInfoResponseTypeSchema = z.nativeEnum(IpawsCapMessageInfoResponseType);

export const IpawsCapMessageInfoSeveritySchema = z.nativeEnum(IpawsCapMessageInfoSeverity);

export const IpawsCapMessageInfoTzCodeSchema = z.nativeEnum(IpawsCapMessageInfoTzCode);

export const IpawsCapMessageInfoUrgencySchema = z.nativeEnum(IpawsCapMessageInfoUrgency);

export const IpawsCapMessageInfoWeaHandlingSchema = z.nativeEnum(IpawsCapMessageInfoWeaHandling);

export const IpawsCapMessageScopeSchema = z.nativeEnum(IpawsCapMessageScope);

export const IpawsCapMessageStatusSchema = z.nativeEnum(IpawsCapMessageStatus);

export const IpawsCapMessageTypeSchema = z.nativeEnum(IpawsCapMessageType);

export const IpawsCertificateTypeSchema = z.nativeEnum(IpawsCertificateType);

export const IpawsChannelSchema = z.nativeEnum(IpawsChannel);

export const IpawsEventCodeSchema = z.nativeEnum(IpawsEventCode);

export const IpawsMessageDataStatusSchema = z.nativeEnum(IpawsMessageDataStatus);

export const IpawsTemplatesSortOptionsSchema = z.nativeEnum(IpawsTemplatesSortOptions);

export const LanguageSchema = z.nativeEnum(Language);

export const MessageSeveritySchema = z.nativeEnum(MessageSeverity);

export const MessageStatusSchema = z.nativeEnum(MessageStatus);

export const PermissionSchema = z.nativeEnum(Permission);

export const PermissionTypeSchema = z.nativeEnum(PermissionType);

export const PhoneProviderSchema = z.nativeEnum(PhoneProvider);

export const SortOrderSchema = z.nativeEnum(SortOrder);

export const StatusSchema = z.nativeEnum(Status);

export const TemplateTypeSchema = z.nativeEnum(TemplateType);

export const TemplatesSortOptionsSchema = z.nativeEnum(TemplatesSortOptions);

export const UserStatusSchema = z.nativeEnum(UserStatus);

export function AccessTokenInfoInputSchema(): z.ZodObject<Properties<AccessTokenInfoInput>> {
  return z.object({
    expiration: z.string().nullish(),
    name: z.string(),
    userId: z.string().nullish()
  })
}

export function AssignCustomerRoleParamsInputSchema(): z.ZodObject<Properties<AssignCustomerRoleParamsInput>> {
  return z.object({
    roleId: z.string(),
    userId: z.string()
  })
}

export function AssignGroupRoleParamsInputSchema(): z.ZodObject<Properties<AssignGroupRoleParamsInput>> {
  return z.object({
    groupId: z.string(),
    roleId: z.string(),
    userId: z.string()
  })
}

export function AssignIpawsRoleParamsInputSchema(): z.ZodObject<Properties<AssignIpawsRoleParamsInput>> {
  return z.object({
    ipawsCertId: z.string(),
    roleId: z.string(),
    userId: z.string()
  })
}

export function AssignTopicRoleParamsInputSchema(): z.ZodObject<Properties<AssignTopicRoleParamsInput>> {
  return z.object({
    roleId: z.string(),
    topicId: z.string(),
    userId: z.string()
  })
}

export function AudienceInfoInputSchema(): z.ZodObject<Properties<AudienceInfoInput>> {
  return z.object({
    geofilters: z.array(z.string()),
    geometries: z.array(z.string()),
    groups: z.array(z.string()),
    topics: z.array(z.string()),
    users: z.array(z.string())
  })
}

export function CmOptionInputSchema(): z.ZodObject<Properties<CmOptionInput>> {
  return z.object({
    method: CmSchema
  })
}

export function CreateGeoFilterParametersInputSchema(): z.ZodObject<Properties<CreateGeoFilterParametersInput>> {
  return z.object({
    boundary: z.string(),
    icon: z.string().nullish(),
    layerId: z.string().nullish(),
    name: z.string()
  })
}

export function CreateGeoLayerParametersInputSchema(): z.ZodObject<Properties<CreateGeoLayerParametersInput>> {
  return z.object({
    name: z.string()
  })
}

export function CreateGroupParametersInputSchema(): z.ZodObject<Properties<CreateGroupParametersInput>> {
  return z.object({
    internalJoinable: z.boolean(),
    members: z.array(z.string()),
    name: z.string(),
    parentGroupIds: z.array(z.string()),
    uuid: z.string().nullish()
  })
}

export function CreateIpawsCertInfoInputSchema(): z.ZodObject<Properties<CreateIpawsCertInfoInput>> {
  return z.object({
    assignRoles: z.array(z.lazy(() => CreateIpawsCertRoleInputSchema())).nullish(),
    boundaries: z.array(z.lazy(() => IpawsCertBoundaryInfoInputSchema())),
    cogId: z.string(),
    description: z.string(),
    keystoreAliasPassword: z.string(),
    keystoreB64: z.string(),
    keystorePassword: z.string(),
    name: z.string(),
    type: IpawsCertificateTypeSchema
  })
}

export function CreateIpawsCertRoleInputSchema(): z.ZodObject<Properties<CreateIpawsCertRoleInput>> {
  return z.object({
    roleId: z.string(),
    userIds: z.array(z.string())
  })
}

export function CreateOptInUserParametersInputSchema(): z.ZodObject<Properties<CreateOptInUserParametersInput>> {
  return z.object({
    address: z.lazy(() => UserAddressInputSchema().nullish()),
    customerId: z.string(),
    expiration: z.string().nullish(),
    language: LanguageSchema,
    name: z.string().nullish()
  })
}

export function CreateTopicParametersInputSchema(): z.ZodObject<Properties<CreateTopicParametersInput>> {
  return z.object({
    description: z.string().nullish(),
    isCategory: z.boolean(),
    isRequired: z.boolean(),
    name: z.string(),
    parentId: z.string()
  })
}

export function CustomFieldParameterInputSchema(): z.ZodObject<Properties<CustomFieldParameterInput>> {
  return z.object({
    description: z.string(),
    name: z.string(),
    options: z.array(z.string()).nullish(),
    type: CustomFieldTypeSchema
  })
}

export function CustomerBlackoutPeriodInfoInputSchema(): z.ZodObject<Properties<CustomerBlackoutPeriodInfoInput>> {
  return z.object({
    end: z.number(),
    start: z.number()
  })
}

export function CustomizationInfoInputSchema(): z.ZodObject<Properties<CustomizationInfoInput>> {
  return z.object({
    enabled: z.boolean(),
    method: CmSchema,
    value: z.string()
  })
}

export function DraftInfoInputSchema(): z.ZodObject<Properties<DraftInfoInput>> {
  return z.object({
    acknowledgable: z.boolean().nullish(),
    audience: z.lazy(() => AudienceInfoInputSchema()),
    duration: z.lazy(() => DurationInfoInputSchema().nullish()),
    escalations: z.array(z.lazy(() => EscalationInfoInputSchema())),
    files: z.array(z.string()),
    locales: z.array(z.lazy(() => LocaleInfoInputSchema())),
    options: z.array(z.lazy(() => CmOptionInputSchema())),
    poll: z.lazy(() => PollInfoInputSchema().nullish()),
    sender: z.string(),
    severity: MessageSeveritySchema
  })
}

export function DurationInfoInputSchema(): z.ZodObject<Properties<DurationInfoInput>> {
  return z.object({
    absolute: z.string().nullish(),
    span: z.number().nullish()
  })
}

export function EmailAddressParamsInputSchema(): z.ZodObject<Properties<EmailAddressParamsInput>> {
  return z.object({
    email: z.string()
  })
}

export function EndUserDeviceParameterInputSchema(): z.ZodObject<Properties<EndUserDeviceParameterInput>> {
  return z.object({
    name: z.string().nullish(),
    overrideVerification: z.boolean().nullish(),
    sendVerification: z.boolean().nullish(),
    type: CmSchema,
    value: z.string()
  })
}

export function EndUserDeviceUpdateParameterInputSchema(): z.ZodObject<Properties<EndUserDeviceUpdateParameterInput>> {
  return z.object({
    name: z.string().nullish(),
    value: z.string()
  })
}

export function EscalationInfoInputSchema(): z.ZodObject<Properties<EscalationInfoInput>> {
  return z.object({
    delaySec: z.number()
  })
}

export function ImportEudInputSchema(): z.ZodObject<Properties<ImportEudInput>> {
  return z.object({
    type: CmSchema,
    value: z.string()
  })
}

export function ImportGroupInputSchema(): z.ZodObject<Properties<ImportGroupInput>> {
  return z.object({
    name: z.string(),
    parentName: z.string()
  })
}

export function ImportUserInputSchema(): z.ZodObject<Properties<ImportUserInput>> {
  return z.object({
    address: z.lazy(() => UserAddressInputSchema().nullish()),
    euds: z.array(z.lazy(() => ImportEudInputSchema())),
    groups: z.array(z.string()),
    loginEmail: z.string().nullish(),
    name: z.string().nullish()
  })
}

export function ImportUsersParametersInputSchema(): z.ZodObject<Properties<ImportUsersParametersInput>> {
  return z.object({
    autoVerifyEuds: z.boolean(),
    importAsOptInUser: z.boolean(),
    language: LanguageSchema.nullish(),
    users: z.array(z.lazy(() => ImportUserInputSchema()))
  })
}

export function IngestRuleInfoInputSchema(): z.ZodObject<Properties<IngestRuleInfoInput>> {
  return z.object({
    destinationTemplateId: z.string(),
    matchExpr: z.string(),
    matchKey: z.string()
  })
}

export function IpawsCertBoundaryInfoInputSchema(): z.ZodObject<Properties<IpawsCertBoundaryInfoInput>> {
  return z.object({
    name: z.string(),
    polygon: z.string()
  })
}

export function IpawsCertChannelInfoInputSchema(): z.ZodObject<Properties<IpawsCertChannelInfoInput>> {
  return z.object({
    channel: IpawsChannelSchema,
    userEnabled: z.boolean()
  })
}

export function IpawsMessageDataAreaCircleInputSchema(): z.ZodObject<Properties<IpawsMessageDataAreaCircleInput>> {
  return z.object({
    point: z.string(),
    radius: z.number()
  })
}

export function IpawsMessageDataAreaInputSchema(): z.ZodObject<Properties<IpawsMessageDataAreaInput>> {
  return z.object({
    circles: z.array(z.lazy(() => IpawsMessageDataAreaCircleInputSchema())),
    codes: z.array(z.string()),
    name: z.string(),
    polygons: z.array(z.string())
  })
}

export function IpawsMessageDataContentInputSchema(): z.ZodObject<Properties<IpawsMessageDataContentInput>> {
  return z.object({
    contactInfo: z.string(),
    description: z.string(),
    easAudioFileId: z.string().nullish(),
    headline: z.string(),
    instructions: z.string().nullish(),
    language: LanguageSchema,
    wea: z.lazy(() => IpawsMessageDataContentWeaInputSchema().nullish())
  })
}

export function IpawsMessageDataContentWeaInputSchema(): z.ZodObject<Properties<IpawsMessageDataContentWeaInput>> {
  return z.object({
    longText: z.string(),
    shortText: z.string()
  })
}

export function IpawsMessageDataInputSchema(): z.ZodObject<Properties<IpawsMessageDataInput>> {
  return z.object({
    areas: z.array(z.lazy(() => IpawsMessageDataAreaInputSchema())),
    category: IpawsCapMessageInfoCategorySchema,
    certId: z.string(),
    certainty: IpawsCapMessageInfoCertaintySchema,
    channels: z.array(IpawsChannelSchema),
    cogRecipients: z.array(z.number()),
    contents: z.array(z.lazy(() => IpawsMessageDataContentInputSchema())),
    customerId: z.string(),
    durationMinutes: z.number(),
    eventCode: IpawsEventCodeSchema,
    note: z.string().nullish(),
    restrictions: z.string().nullish(),
    scope: IpawsCapMessageScopeSchema,
    severity: IpawsCapMessageInfoSeveritySchema,
    status: IpawsMessageDataStatusSchema,
    tz: IpawsCapMessageInfoTzCodeSchema,
    urgency: IpawsCapMessageInfoUrgencySchema
  })
}

export function IpawsTemplatesSearchParametersInputSchema(): z.ZodObject<Properties<IpawsTemplatesSearchParametersInput>> {
  return z.object({
    environment: IpawsCertificateTypeSchema.nullish(),
    eventCode: IpawsEventCodeSchema.nullish(),
    query: z.string().nullish(),
    sort: z.lazy(() => IpawsTemplatesSortConfigInputSchema().nullish())
  })
}

export function IpawsTemplatesSortConfigInputSchema(): z.ZodObject<Properties<IpawsTemplatesSortConfigInput>> {
  return z.object({
    by: IpawsTemplatesSortOptionsSchema,
    direction: SortOrderSchema
  })
}

export function KeyValueInputSchema(): z.ZodObject<Properties<KeyValueInput>> {
  return z.object({
    key: z.string(),
    value: z.string()
  })
}

export function LocaleInfoInputSchema(): z.ZodObject<Properties<LocaleInfoInput>> {
  return z.object({
    body: z.string(),
    customizations: z.array(z.lazy(() => CustomizationInfoInputSchema())).nullish(),
    language: LanguageSchema,
    richBody: z.string(),
    subject: z.string()
  })
}

export function NoteLocaleInfoInputSchema(): z.ZodObject<Properties<NoteLocaleInfoInput>> {
  return z.object({
    body: z.string(),
    language: LanguageSchema,
    richBody: z.string(),
    subject: z.string()
  })
}

export function OptInUserSearchParametersInputSchema(): z.ZodObject<Properties<OptInUserSearchParametersInput>> {
  return z.object({
    email: z.string().nullish(),
    name: z.string().nullish(),
    phoneNumber: z.string().nullish()
  })
}

export function OptionInfoInputSchema(): z.ZodObject<Properties<OptionInfoInput>> {
  return z.object({
    content: z.string()
  })
}

export function PollInfoInputSchema(): z.ZodObject<Properties<PollInfoInput>> {
  return z.object({
    content: z.string(),
    options: z.array(z.lazy(() => OptionInfoInputSchema()))
  })
}

export function RoleParamsInputSchema(): z.ZodObject<Properties<RoleParamsInput>> {
  return z.object({
    description: z.string(),
    name: z.string(),
    permissions: z.array(PermissionSchema),
    type: PermissionTypeSchema
  })
}

export function SendEudLoginCodeParamsInputSchema(): z.ZodObject<Properties<SendEudLoginCodeParamsInput>> {
  return z.object({
    customerId: z.string(),
    type: CmSchema,
    value: z.string()
  })
}

export function SenderInfoInputSchema(): z.ZodObject<Properties<SenderInfoInput>> {
  return z.object({
    emailFooter: z.string().nullish(),
    emailHeader: z.string().nullish(),
    fromEmail: z.string(),
    fromPhone: z.string(),
    group: z.string(),
    name: z.string(),
    verificationSender: z.boolean().nullish()
  })
}

export function SetTemplateTypeParamsInputSchema(): z.ZodObject<Properties<SetTemplateTypeParamsInput>> {
  return z.object({
    id: z.string(),
    type: TemplateTypeSchema
  })
}

export function TemplateInfoV2InputSchema(): z.ZodObject<Properties<TemplateInfoV2Input>> {
  return z.object({
    message: z.lazy(() => DraftInfoInputSchema())
  })
}

export function TemplatesSearchParametersInputSchema(): z.ZodObject<Properties<TemplatesSearchParametersInput>> {
  return z.object({
    groupId: z.string().nullish(),
    query: z.string().nullish(),
    severity: MessageSeveritySchema.nullish(),
    sort: z.lazy(() => TemplatesSortConfigInputSchema().nullish())
  })
}

export function TemplatesSortConfigInputSchema(): z.ZodObject<Properties<TemplatesSortConfigInput>> {
  return z.object({
    by: TemplatesSortOptionsSchema,
    direction: SortOrderSchema
  })
}

export function UpdateGroupParametersInputSchema(): z.ZodObject<Properties<UpdateGroupParametersInput>> {
  return z.object({
    internalJoinable: z.boolean(),
    name: z.string()
  })
}

export function UpdateIpawsCertInfoInputSchema(): z.ZodObject<Properties<UpdateIpawsCertInfoInput>> {
  return z.object({
    boundaries: z.array(z.lazy(() => IpawsCertBoundaryInfoInputSchema())),
    channels: z.array(z.lazy(() => IpawsCertChannelInfoInputSchema())),
    description: z.string(),
    enabled: z.boolean(),
    name: z.string()
  })
}

export function UpdateRoleParametersInputSchema(): z.ZodObject<Properties<UpdateRoleParametersInput>> {
  return z.object({
    permissions: z.array(PermissionSchema),
    roleId: z.string()
  })
}

export function UpdateSenderParametersInputSchema(): z.ZodObject<Properties<UpdateSenderParametersInput>> {
  return z.object({
    fromEmailAddress: z.string(),
    fromPhone: z.string(),
    group: z.string().nullish(),
    isSystem: z.boolean().nullish(),
    name: z.string(),
    verificationSender: z.boolean()
  })
}

export function UpdateTopicParametersInputSchema(): z.ZodObject<Properties<UpdateTopicParametersInput>> {
  return z.object({
    description: z.string().nullish(),
    name: z.string()
  })
}

export function UpdateUserParametersInputSchema(): z.ZodObject<Properties<UpdateUserParametersInput>> {
  return z.object({
    language: LanguageSchema,
    name: z.string()
  })
}

export function UserAddressInputSchema(): z.ZodObject<Properties<UserAddressInput>> {
  return z.object({
    city: z.string(),
    name: z.string(),
    state: z.string(),
    street: z.string(),
    street2: z.string().nullish(),
    zip: z.string()
  })
}

export function UserCustomFieldParametersInputSchema(): z.ZodObject<Properties<UserCustomFieldParametersInput>> {
  return z.object({
    customFieldId: z.string(),
    value: z.string()
  })
}

export function ValidateIpawsAlertBoundaryParamsInputSchema(): z.ZodObject<Properties<ValidateIpawsAlertBoundaryParamsInput>> {
  return z.object({
    boundary: z.array(z.string()),
    certId: z.string()
  })
}

export function VerifyEudLoginCodeParamsInputSchema(): z.ZodObject<Properties<VerifyEudLoginCodeParamsInput>> {
  return z.object({
    customerId: z.string(),
    type: CmSchema,
    value: z.string(),
    verificationCode: z.string()
  })
}

export function WeatherZoneParametersInputSchema(): z.ZodObject<Properties<WeatherZoneParametersInput>> {
  return z.object({
    senderId: z.string(),
    topicId: z.string(),
    zoneId: z.string()
  })
}

export function WeatherZonesParametersInputSchema(): z.ZodObject<Properties<WeatherZonesParametersInput>> {
  return z.object({
    senderId: z.string(),
    topicId: z.string(),
    zoneIds: z.array(z.string())
  })
}
